import React, { useState } from 'react';
import { Star } from 'lucide-react';

const SIZES = {
  sm: { icon: 14, gap: 'gap-0.5' },
  md: { icon: 18, gap: 'gap-1' },
  lg: { icon: 22, gap: 'gap-1.5' },
};

const StarRating = ({ value = null, onChange, size = 'md' }) => {
  const [hovered, setHovered] = useState(null);
  const isEditable = typeof onChange === 'function';
  const { icon: iconSize, gap } = SIZES?.[size] || SIZES?.md;

  const displayValue = hovered !== null ? hovered : value;

  const handleClick = (starIndex) => {
    if (!isEditable) return;
    // Click same star again → clear to null
    if (value === starIndex) {
      onChange(null);
    } else {
      onChange(starIndex);
    }
  };

  if (!isEditable && value === null) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  return (
    <div
      className={`flex items-center ${gap}`}
      onMouseLeave={() => isEditable && setHovered(null)}
    >
      {[1, 2, 3, 4, 5]?.map((star) => {
        const filled = displayValue !== null && star <= displayValue;
        return (
          <button
            key={star}
            type="button"
            disabled={!isEditable}
            onClick={() => handleClick(star)}
            onMouseEnter={() => isEditable && setHovered(star)}
            className={`focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors ${isEditable ? 'cursor-pointer' : 'cursor-default'}`}
            style={{ padding: 0, background: 'none', border: 'none' }}
          >
            <Star
              size={iconSize}
              fill={filled ? '#FF6B2C' : 'none'}
              stroke={filled ? '#FF6B2C' : '#9CA3AF'}
              strokeWidth={1.5}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
